import { css } from "styled-components";
import { spaceMixin } from "../spaceMixin";
/** @class PropertyCardDataWrapperMixin */

/** @method */

export var PropertyCardDataWrapperMixin = function PropertyCardDataWrapperMixin(props) {
  return css(["align-content:start;display:grid;grid-area:data;grid-column-gap:", ";grid-template-areas:\"title actions\" \"body1 body1\" \"body2 body2\" \"body3 body3\" \"additionalInfo additionalInfo\";grid-template-columns:1fr min-content;justify-content:space-between;"], spaceMixin("sm")(props));
};